import React from 'react';

import styles from '../styles/Loading.css';

export default (props) => {
  const { progress } = props;
  return (
    <div className={styles.loading}>
      <h1 className={styles.title}>Loading</h1>
      <div className={styles.progressBar}>
        <div className={styles.progressBarInner} style={{width:(progress*100)+'%'}}></div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Loading.js